import { createAction } from '@reduxjs/toolkit';

import type { Address } from 'domains/addresses';
import type { ShippingMethod } from './shipping_methods.types';

const getAll = {
  pending: createAction<Address>('shippingMethods/getShippingMethods/pending'),
  fulfilled: createAction<ShippingMethod[]>('shippingMethods/getShippingMethods/fulfilled'),
  rejected: createAction('shippingMethods/getShippingMethods/rejected'),
};

const getPickups = {
  pending: createAction('shippingMethods/getPickups/pending'),
  fulfilled: createAction<ShippingMethod[]>('shippingMethods/getPickups/fulfilled'),
  rejected: createAction('shippingMethods/getPickups/rejected'),
};

export default {
  getAll,
  getPickups,
};
